export const minCharts: number = 3;
export const timeDelay: number = 1000; // milliseconds
export const pageSize: number = 100;